var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsumablesHowItWorksStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.8335,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "url(#paint0_linear_2430_205240)",
    strokeOpacity: 0.2,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.1897 29V26.3409L20.4027 20.5881C20.9312 20.0767 21.3743 19.6165 21.7323 19.2074C22.0959 18.7983 22.3715 18.3977 22.559 18.0057C22.7465 17.608 22.8402 17.179 22.8402 16.7188C22.8402 16.2074 22.7238 15.767 22.4908 15.3977C22.2579 15.0227 21.9397 14.7358 21.5363 14.5369C21.1329 14.3324 20.6755 14.2301 20.1641 14.2301C19.63 14.2301 19.1641 14.3381 18.7664 14.554C18.3687 14.7699 18.0618 15.0795 17.8459 15.483C17.63 15.8864 17.5221 16.3665 17.5221 16.9233H14.0192C14.0192 15.7812 14.2777 14.7898 14.7948 13.9489C15.3118 13.108 16.0363 12.4574 16.9681 11.9972C17.8999 11.5369 18.9738 11.3068 20.1897 11.3068C21.4397 11.3068 22.5277 11.5284 23.4539 11.9716C24.3857 12.4091 25.1101 13.017 25.6272 13.7955C26.1442 14.5739 26.4027 15.4659 26.4027 16.4716C26.4027 17.1307 26.2721 17.7812 26.0107 18.4233C25.755 19.0653 25.2976 19.7784 24.6385 20.5625C23.9794 21.3409 23.0505 22.2756 21.8516 23.3665L19.3033 25.8636V25.983H26.6329V29H14.1897Z",
    fill: "url(#paint1_linear_2430_205240)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2430_205240",
    x1: 0.333489,
    y1: 39.9999,
    x2: 43.1887,
    y2: 36.6624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2430_205240",
    x1: 0.333489,
    y1: 33.9999,
    x2: 42.9215,
    y2: 29.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumablesHowItWorksStep2);
export default __webpack_public_path__ + "static/media/consumables_how_it_works_step_2.a481bef615ccb3a227a4c1d1d3b5ee9a.svg";
export { ForwardRef as ReactComponent };